import PolishFlag from "assets/poland.png";
import EnglishFlag from "assets/english.png";

export const languages = [
  { id: 1, title: "Polski", image: PolishFlag, slug: "pl" },
  { id: 2, title: "English", image: EnglishFlag, slug: "en" },
];
